import Vue from 'vue';
import Component from 'vue-class-component';
import FormResStatus from '@/api/form-res-status';
import REQ_URL from '@/consts/req-url';

@Component({

})
export default class RecoveryPassword extends Vue {
    resetPassData = {
        oldPass: '',
        newPass: '',
        newPassRetry: ''
    }
    formStatus = new FormResStatus()
    passRetryValidation(v: string) {
        return this.resetPassData.newPass === this.resetPassData.newPassRetry || 'Пароли должны совпадать'
    }
    required(v: string) {
        return  !!v || 'Заполните поле'
    }
    resetPassForm() {
        (this.$refs.passForm as any).reset()
        this.resetPassData.oldPass = this.resetPassData.newPass = this.resetPassData.newPassRetry = ''
    }
    async changePass() {
        if (!(this.$refs.passForm as any).validate()) return;
        try {
            let data = await this.$fetch<undefined | null>(REQ_URL.CHANGE_PASS,{
                method: 'POST',
                body: JSON.stringify(this.resetPassData)
            }, this.formStatus)
            if (data.msg) {
                this.$store.commit('modal:open', {
                    type: 'success',
                    msg: data.msg
                })
                this.resetPassForm()
            }
            else throw new Error(data.error)
        } catch (error) {
            
            this.$store.commit('modal:open', {
                type: 'error',
                msg: this.formStatus.getError('form') ? this.formStatus.getError('form') : error.message
            })
            console.error(error.message)
        }
    }
}